import { Component, inject } from '@angular/core';
import {
  ConsumableResourceCreateDto,
  ConsumableResourceDto,
  ConsumableResourceExcelDownloadDto,
  ConsumableResourceService,
  ConsumableResourceUpdateDto,
} from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import { CONSUMABLERESOURCE_CONFIG, CONSUMABLERESOURCE_FIELDS } from './consumable-resource.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-consumable-resource',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ConsumableResourceService, ConfirmationService],
  templateUrl: './consumable-resource.html',
  styleUrl: './consumable-resource.scss',
})
export class ConsumableResource extends BaseCrudComponent<
  ConsumableResourceDto,
  ConsumableResourceCreateDto,
  ConsumableResourceUpdateDto,
  ConsumableResourceExcelDownloadDto
> {
  service = inject(ConsumableResourceService);
  config = CONSUMABLERESOURCE_CONFIG;
  fields = CONSUMABLERESOURCE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ConsumableResourceDto): ConsumableResourceUpdateDto {
    return {
      canSubmitConsumptionToSap: data.canSubmitConsumptionToSap,
      acceptedDeviation: data.acceptedDeviation,
      geneticMaterialId: data.geneticMaterialId,
      consumableId: data.consumableId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ConsumableResource';
  }
}
